import {Widget} from "./index";
import React from "react";
import DataDisplayWidget from "../../components/shared-components/DataDisplayWidget";

export class WidgetDataDisplay extends Widget {

  constructor(obj = {}) {
    super(obj);

    this.value = obj.value;
    this.icon = obj.icon;
    this.color = obj.color;
    this.avatarSize = obj.avatarSize ?? 50;
    this.vertical = obj.vertical ?? false;
  }

  getComponent() {
    return () => (
      <DataDisplayWidget
        title={this.title}
        value={this.value}
        size={this.size}
        icon={this.icon}
        color={this.color}
        avatarSize={this.avatarSize}
        vertical={this.vertical}
      />
    );
  }

  transformToWidget = (data) => {
    this.title = data.title;
    this.type = data.type;
    this.size = data.size;
    this.value = data.value;
    this.icon = data.icon;
    this.color = data.color;
    this.avatarSize = data.avatarSize;
    this.vertical = data.vertical;
    return this;
  }
}
